import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { FormCategory } from '@nrwl/rx-models';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@nrwl/environment';
import { FormCategoryQueryParams } from 'libs/models/form/form-category-query-params';
import { PaginatedApiResponse } from 'libs/models/pagination/paginated-api-response';

@Injectable({
  providedIn: 'root',
})
export class FormCategoryService {
  public formCategoryChanged: Subject<FormCategory[]> = new Subject<FormCategory[]>();
  private _formCategories: FormCategory[] = [];

  constructor(private http: HttpClient) {}

  get formCategories() {
    return this._formCategories;
  }

  set formCategories(value: FormCategory[]) {
    this._formCategories = value;
    this.formCategoryChanged.next(this._formCategories);
  }

  public formCategoryChangedEmit() {
    this.formCategoryChanged.next(this._formCategories);
  }

  public getFormCategories(): Observable<FormCategory[]> {
    // 2020-08-11: v2 to v3 test as per Turker suggestion
    return this.http
      .get(environment.baseAPIUrlv3 + 'formcategory/?is_deleted=false')
      .pipe(map((res: any) => res.map((template: any) => new FormCategory(template))));
  }

  public getFormCategoriesPaginated(
    params: FormCategoryQueryParams = {},
  ): Observable<PaginatedApiResponse<FormCategory>> {
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return this.http
      .get<
        PaginatedApiResponse<FormCategory>
      >(environment.baseAPIUrlv3 + 'formcategory/', { params: httpParams })
      .pipe(
        map((res) => ({
          ...res,
          results: res.results.map((item) => new FormCategory(item)),
        })),
      );
  }

  public getFormCategoriesList(params: FormCategoryQueryParams = {}): Observable<FormCategory[]> {
    let httpParams = new HttpParams();

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && key !== 'page' && key !== 'page_size') {
        httpParams = httpParams.set(key, String(value));
      }
    });

    return this.http
      .get<FormCategory[]>(environment.baseAPIUrlv3 + 'formcategory/', { params: httpParams })
      .pipe(map((res: FormCategory[]) => (res || []).map((item) => new FormCategory(item))));
  }

  public getFormCategoryByID(id: number): Observable<FormCategory> {
    // 2020-08-11: v2 to v3 test as per Turker suggestion
    return this.http
      .get(environment.baseAPIUrlv3 + 'formcategory/' + id + '/')
      .pipe(map((res: any) => new FormCategory(res)));
  }

  public save(categoryId, data: FormCategory): Observable<any> {
    // 2020-08-11: v2 to v3 test as per Turker suggestion
    return this.http.patch(environment.baseAPIUrlv3 + `formcategory/${categoryId}/`, data);
  }

  public create(data: FormCategory): Observable<any> {
    // 2020-08-11: v2 to v3 test as per Turker suggestion
    return this.http
      .post(environment.baseAPIUrlv3 + `formcategory/`, data)
      .pipe(map((res: any) => new FormCategory(res)));
  }

  // TODO: DANGER: REPLACE PATCH WITH DELETE ONCE RWE-334 IS DONE
  // DELETE METHOD PHYSICALLY REMOVES FormTemplates (!)
  public delete(categoryId): Observable<any> {
    // 2020-08-11: v2 to v3 test as per Turker suggestion
    return this.http.delete(environment.baseAPIUrlv3 + `formcategory/${categoryId}/`);
    // , {
    // 	is_deleted: true
    // }
  }
}
